import { render, staticRenderFns } from "./EventsHistory.vue?vue&type=template&id=afa92b28"
import script from "./EventsHistory.vue?vue&type=script&lang=js"
export * from "./EventsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports